import { ref } from 'vue'

// Add more menu types as needed
export type MenuType = 'contact' | 'apps'

const activeMenu = ref<MenuType | null>(null)

/**
 * Side menu store for managing the active side menu globally
 */
export const useSideMenuStore = () => {
  const openMenu = (type: MenuType) => {
    activeMenu.value = type
  }

  const closeMenu = () => {
    activeMenu.value = null
  }

  return {
    activeMenu,
    openMenu,
    closeMenu
  }
}